/** @jsx jsx */
import { jsx } from "@emotion/react";
import { useIntl } from "react-intl";
import { useTheme } from "../../../../config/emotion";

import EwaButton2 from "./EwaButton/EwaButton2";
import { PurposedButtonProps } from "./types";
import { labellessButtonCss } from "./styles";

const SaveButton = (props: PurposedButtonProps) => {
  const { formatMessage } = useIntl();
  const { colors } = useTheme();

  return (
    <EwaButton2
      buttonColor={colors.save}
      tooltip={formatMessage({ id: "common.save" })}
      iconName="save"
      css={labellessButtonCss}
      {...props}
    />
  );
};

export default SaveButton;
